import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import {
  buildTimezoneOptions,
  getBrowserTimezone,
} from "../../utils/timezoneUtils";

type TProps = {
  value?: string;
  preferredTimezones?: string[];
  onChange: (timezone: string) => void;
};

export const TimezoneSelect: React.FC<TProps> = ({
  value,
  preferredTimezones = [],
  onChange,
}) => {
  const { t } = useTranslation();
  const browserTimezone = getBrowserTimezone();
  const options = useMemo(
    () => buildTimezoneOptions(preferredTimezones),
    [preferredTimezones],
  );
  const selectedValue = value || browserTimezone;

  return (
    <div>
      <Select
        inputId="scheduleTimezone"
        options={options}
        value={options.find((option) => option.value === selectedValue) ?? null}
        onChange={(option) => {
          if (option?.value) {
            onChange(option.value);
          }
        }}
        isSearchable
        placeholder={t("scheduleTimezone")}
      />
      <small className="text-muted d-block mt-1">
        {t("scheduleTimezoneBrowserDefault", { timezone: browserTimezone })}
      </small>
    </div>
  );
};
